export const isEmpty = (label) => {
  if (label === "") return true;
  else return false;
};
